import React from 'react';

// Reusable loading spinner component
export function LoadingSpinner({ size = 45, color = "#3b82f6" }) {
  const spinnerStyle = {
    width: size,
    height: size,
    border: "5px solid rgba(255,255,255,0.2)",
    borderTopColor: color,
    borderRadius: "50%",
    margin: "0 auto",
    animation: "spin 0.8s linear infinite",
  };

  return <div style={spinnerStyle}></div>;
}

// Loading card for page-level loading
export function LoadingCard({ message = "Loading your data..." }) {
  const cardStyle = {
    background: "rgba(3, 18, 40, 0.85)",
    border: "1px solid #2563eb55",
    borderRadius: 16,
    padding: 30,
    textAlign: "center",
    backdropFilter: "blur(6px)",
    maxWidth: 400,
    margin: "0 auto",
  };

  const textStyle = {
    color: "#9ecbff",
    fontSize: 16,
    fontWeight: 500,
    marginTop: 20,
  };

  return (
    <div style={cardStyle}>
      <LoadingSpinner />
      <div style={textStyle}>{message}</div>
    </div>
  );
}

// Loading overlay for full screen loading
export function LoadingOverlay({ message = "Loading..." }) {
  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  };

  const textStyle = {
    color: "#9ecbff",
    fontSize: 16,
    fontWeight: 500,
    marginTop: 20,
  };

  return (
    <div style={overlayStyle}>
      <LoadingSpinner />
      <div style={textStyle}>{message}</div>
    </div>
  );
}

// Skeleton loading for content placeholders
export function SkeletonLoader({ width = "100%", height = 20, marginBottom = 10 }) {
  const skeletonStyle = {
    width,
    height,
    marginBottom,
    background: "linear-gradient(90deg, rgba(255,255,255,0.05) 25%, rgba(255,255,255,0.1) 50%, rgba(255,255,255,0.05) 75%)",
    backgroundSize: "200% 100%",
    animation: "skeleton-loading 1.5s infinite",
    borderRadius: 4,
  };

  return <div style={skeletonStyle}></div>;
}

// Inject CSS animations if not already present
if (typeof document !== 'undefined' && !document.querySelector('#loading-animations')) {
  const styleSheet = document.createElement("style");
  styleSheet.id = "loading-animations";
  styleSheet.type = "text/css";
  styleSheet.innerText = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    
    @keyframes skeleton-loading {
      0% { background-position: 200% 0; }
      100% { background-position: -200% 0; }
    }
  `;
  document.head.appendChild(styleSheet);
}